import { render, staticRenderFns } from "./BookingStatusLabel.vue?vue&type=template&id=17f7c361&"
import script from "./BookingStatusLabel.vue?vue&type=script&lang=js&"
export * from "./BookingStatusLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports